import { render, staticRenderFns } from "./ExternalApprovalPage.vue?vue&type=template&id=3bc33a8c&scoped=true"
import script from "./ExternalApprovalPage.vue?vue&type=script&lang=js"
export * from "./ExternalApprovalPage.vue?vue&type=script&lang=js"
import style0 from "./ExternalApprovalPage.vue?vue&type=style&index=0&id=3bc33a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc33a8c",
  null
  
)

export default component.exports